import React from "react";
import { useIntl } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { useIconColorClasses, Icon } from "../icons/Icon.js";
import "../icons/ExpandMoreIcon.js";
import { EmptyLabel } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import { withLink } from "./LinkHOC.js";
const useStyles = makeStyles()((theme) => ({
  iconLinkContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    height: theme.custom.defaultChipHeight,
    background: theme.palette.background.paper,
    border: `1px solid ${theme.custom.palette.content.border}`,
    boxShadow: theme.custom.defaultChipBoxShadow,
    borderRadius: theme.custom.defaultBorderRadius * 4,
    gap: theme.spacing(1),
    textDecoration: "none",
    color: theme.custom.palette.status.lightGrey.main,
    lineHeight: `${theme.custom.defaultChipHeight}px`,
    boxSizing: "content-box",
    fontSize: theme.typography.body1.fontSize,
    justifyContent: "center",
    "& > *": {
      borderRight: `1px solid ${theme.custom.palette.content.border}`,
      display: "flex",
      gap: theme.spacing(1),
      paddingRight: theme.spacing(1),
      alignItems: "center"
    },
    "& > *:last-child": {
      borderRight: "none",
      paddingRight: 0
    }
  },
  linkIconChip: {
    "& .icon-linked:last-child": {
      display: "none"
    }
  },
  linkIconCircle: {
    "& .icon-linked:last-child": {
      display: "none"
    },
    borderRadius: theme.custom.defaultBorderRadius * 6,
    height: "40px",
    width: "40px"
  },
  linkIconChipWithLinkIcon: {}
}));
function IconLinkInternal({ linkStyle, ...props }) {
  const { classes } = useStyles();
  const { title, icon, color } = props;
  const iconColorClass = useIconColorClasses()[color];
  const { formatMessage } = useIntl();
  const formattedTitle = title ? typeof title === "string" ? title : formatMessage(title) : "";
  const linkIconStyleClass = getLinkStyle();
  const hasLinkIcon = linkStyle === "chipWithLinkIcon";
  function getLinkStyle() {
    const styles = {
      circle: classes.linkIconCircle,
      chip: classes.linkIconChip,
      chipWithLinkIcon: classes.linkIconChipWithLinkIcon
    };
    return styles[linkStyle];
  }
  return /* @__PURE__ */ React.createElement("div", { className: `${classes.iconLinkContainer} ${linkIconStyleClass}` }, /* @__PURE__ */ React.createElement("span", null, icon ? /* @__PURE__ */ React.createElement(Icon, { icon, ...props, title: formattedTitle }) : /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }), formattedTitle ? /* @__PURE__ */ React.createElement("span", { className: iconColorClass ?? "" }, formattedTitle) : null), hasLinkIcon ? /* @__PURE__ */ React.createElement(Icon, { icon: "icon-linked" }) : null);
}
const LinkButton = withLink(IconLinkInternal, false);
export {
  LinkButton,
  useStyles
};
//# sourceMappingURL=LinkButton.js.map
